export enum PaymentProviderEnum {
  MAXIO = 'MAXIO',
  STRIPE = 'STRIPE',
}
